import RemoveRepository from "@domain/repositories/RemoveRepository";
import UseCase from "@domain/UseCase";
import { RemoveClient } from "@domain/models/RemoveClient";
import { RemoveClientValidation } from "@domain/models/RemoveClientValidation";

type Input = RemoveClient[];

type Output = Promise<RemoveClientValidation>;

export class ValidateClientRemoveUseCase implements UseCase<Input, Output> {
  constructor(private readonly removeRepository: RemoveRepository) {}

  execute(clients: Input) {
    return this.removeRepository.validateRemove(clients);
  }
}
